<template>
  <table class="table table-hover table-mail">
    <thead class="table-head">
      <tr>
        <th>Nome</th>
        <th>Labels</th>
        <th>Data de Abertura</th>
        <th></th>
      </tr>
    </thead>

    <tbody class="table-list">
      <tr v-for="(moviment, listIdx) in linkedAccountingCash" :key="listIdx">
        <td>{{ moviment.name || moviment.user.fullName }}</td>
        <td>{{ moviment.description }}</td>
        <td>{{ moviment.accounting.openedDate }}</td>

        <td>
          <button
            type="button"
            class="btn btn-outline"
            title="Remover"
            @click="removeAccounting(listIdx)"
          >
            <i class="fa fa-trash text-danger"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: {
    value: {
      default: null,
    },
  },
  data() {
    return {
      linkedAccountingCash: this.value,
    };
  },

  watch: {
    value: {
      handler(v) {
        this.linkedAccountingCash = v;
      },
    },
    linkedAccountingCash(v) {
      this.$emit('value', v);
    },
  },
  methods: {
    removeAccounting(index) {
      this.linkedAccountingCash.splice(index, 1);
    },
  },
};
</script>